module.exports = __webpack_public_path__ + "static/media/capisci.54ba0efe.mp3";